// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notification-content-wrapper {
  height: calc(100vh - 200px);
  overflow-y: auto;
}

.modal-dialog .modal-content {
  max-width: calc(100vw - 50px);
}
.modal-dialog .modal-header {
  justify-content: space-between;
}
.modal-dialog .modal-body {
  height: calc(100vh - 150px);
  overflow-y: auto;
  scrollbar-width: none;
}
.modal-dialog .fa-solid {
  font-size: 1.5rem !important;
  color: #fff !important;
}

.modal.fade {
  background: rgba(0, 0, 0, 0.2);
}

.modal.show {
  display: block;
}

.modal-header {
  background: var(--primaryColor);
  color: #fff;
}

.btn-close {
  color: #fff;
}

.userlist {
  height: calc(100vh - 500px);
  overflow-y: auto;
}

.btn-primary {
  background: var(--primaryColor) !important;
  color: #fff !important;
}

.btn-cancel {
  background-color: #eee;
  color: #111;
}

.btn {
  padding: 0.3rem 0.8rem !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/ai-library/ai-library/new-ai-library/new-ai-library.component.scss"],"names":[],"mappings":"AAAA;EACI,2BAAA;EACA,gBAAA;AACJ;;AAGI;EACI,6BAAA;AAAR;AAEI;EACI,8BAAA;AAAR;AAEI;EACE,2BAAA;EACE,gBAAA;EACA,qBAAA;AAAR;AAEI;EACI,4BAAA;EACA,sBAAA;AAAR;;AAGA;EACI,8BAAA;AAAJ;;AAEA;EACI,cAAA;AACJ;;AACA;EACI,+BAAA;EACA,WAAA;AAEJ;;AAAA;EACI,WAAA;AAGJ;;AADA;EACI,2BAAA;EACA,gBAAA;AAIJ;;AAFA;EACI,0CAAA;EACA,sBAAA;AAKJ;;AAHA;EACI,sBAAA;EACA,WAAA;AAMJ;;AAJA;EACI,iCAAA;AAOJ","sourcesContent":[".notification-content-wrapper{\n    height:calc(100vh - 200px);\n    overflow-y: auto;\n}\n\n.modal-dialog{\n    .modal-content{\n        max-width:calc(100vw - 50px);\n    }\n    .modal-header{\n        justify-content: space-between;\n    }\n    .modal-body{\n      height:calc(100vh - 150px);\n        overflow-y: auto;\n        scrollbar-width: none;\n    }\n    .fa-solid{\n        font-size:1.5rem !important;\n        color:#fff !important;\n    }\n}\n.modal.fade{\n    background:rgba(0,0,0,0.2);\n}\n.modal.show{\n    display: block;\n}\n.modal-header{\n    background: var(--primaryColor);\n    color:#fff;\n}\n.btn-close{\n    color: #fff;\n}\n.userlist{\n    height:calc(100vh - 500px);\n    overflow-y: auto;\n}\n.btn-primary{\n    background: var(--primaryColor) !important;\n    color:#fff !important;\n}\n.btn-cancel{\n    background-color:#eee;\n    color:#111;\n}\n.btn{\n    padding:.3rem .8rem !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
